// extracted by mini-css-extract-plugin
export default {"wrap":"standalone-shell_wrap__wsMZp","wordmark":"standalone-shell_wordmark__kOo-F"};